import { render, staticRenderFns } from "./RecuperacaoSenhaOffice.vue?vue&type=template&id=3beabb3d&scoped=true"
import script from "./RecuperacaoSenhaOffice.vue?vue&type=script&lang=js"
export * from "./RecuperacaoSenhaOffice.vue?vue&type=script&lang=js"
import style0 from "./RecuperacaoSenhaOffice.vue?vue&type=style&index=0&id=3beabb3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3beabb3d",
  null
  
)

export default component.exports